import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ProductModel } from "src/app/models/product.model";
import { MathService } from "src/app/services/math/math.service";
import { ProductService } from "src/app/services/product/product.service";
import { AmountEditorComponent } from "../amount-editor/amount-editor.component";

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "quantity-editor",
  templateUrl: "quantity-editor.component.html",
  styleUrls: ["./quantity-editor.component.scss"]
})
export class QuantityEditorComponent implements OnInit {
  @Input()
  disabled=false;

  @Input()
  product:ProductModel = {
    details:{
      unitPriceQuantityMetric:'kilogram',
      unitPriceQuantityMetricType:'weight',
      quantityMetric:'gram',
      quantityMetricType:'weigh',
      quantityIncrement:100,
      quantityMin:100,
      quantityMax:10000,
      unitPriceVATIncluded:5,
      currency:'EUR'
    },
    basket:{
      quantity:1500,
      totalPriceVATIncluded:7.5
    }
  };

  @Output() quantityValidated = new EventEmitter<ProductModel>();

  constructor(private modalCtrl:ModalController) {}

  ngOnInit() {}

  async onClick(){
    if(!this.disabled){
      const modal = await this.modalCtrl.create({
        component: AmountEditorComponent,
        cssClass: 'amount-editor',
        componentProps:{
          product:this.product,
          onValidate: (product:ProductModel) => {
            console.log(product, this.product);
            modal.dismiss();
          }
        }
      });
      return await modal.present();      
    }
  }

  onValidate(){
    this.quantityValidated.emit(this.product);
  }
}
